import axios from "axios";
const baseDomain = process.env.VUE_APP_ROOT_API;
//const baseDomain = '/fairfieldallergyapi/v1/';
const baseURL = `${baseDomain}`; // Incase of /api/v1;

// ALL DEFUALT CONFIGURATION HERE

export default axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    // "Authorization": "Bearer xxxxx"
  }
});
